export const ENV_NAME = 'staging-azure';
export const DISABLE_ANALYTICS = true;
export const BASE_URL = 'https://api-staging-azure.getoutpatient.com/';
export const BASE_WS_URL = 'wss://ws-staging-azure.getoutpatient.com';
export const CLOUD_PROVIDER = 'azure'; // aws | azure
export const S3_PUBLIC_BUCKET_URL = 'https://opdevpublic.blob.core.usgovcloudapi.net/opdevpublic/';
export const TURNSTYLE_SITE_KEY = '0x4AAAAAAAGsiZ8e9RgHaKUR';
export const USE_OKTA = true;
export const OKTA_CLIENT_ID = '0oa102lgvkvuh50XU698';
